export { default } from './ProductQAHighlights';